const home = {
  acadly_home: 'Acadly - Home',
  acadly_in_class_activities: 'Acadly in-class activities',
  which_activity_do_you_want_to_add_to_this_slide: 'Which activity do you want to add to this slide',

  /** slide */
  activity_was_not_added: 'Activity was not added',
} as const;

export default home;
